import { FormFieldValidator } from './FormFieldValidator';
import { FileDescriptor } from '../../../services/fileService';

export class FileFormFieldValidator extends FormFieldValidator {
  static MAX_FILES_COUNT = 3;
  static MAX_FILE_SIZE_MB = 5;
  static MAX_FILE_SIZE_BYTES = FileFormFieldValidator.MAX_FILE_SIZE_MB * 1024 * 1024;

  constructor(isRequired: boolean) {
    super(isRequired, undefined, undefined);
  }

  private lengthCheck(value: FileDescriptor[]) {
    return this.isEmpty(value) ? true : this.countCheck(value) && this.sizeCheck(value);
  }

  private countCheck(value: FileDescriptor[]) {
    return value.length <= FileFormFieldValidator.MAX_FILES_COUNT;
  }

  private sizeCheck(value: FileDescriptor[]) {
    return value.every(
      (file) => Number(file.fileSize?.valueInBytes) <= FileFormFieldValidator.MAX_FILE_SIZE_BYTES,
    );
  }

  protected isValid(value: FileDescriptor[]) {
    return this.isEmpty(value) ? this.requiredCheck(value) : this.lengthCheck(value);
  }
}
